<template>

  <div class="box" v-if="brochures">

      <form class="form wrap form--inline" v-on:submit.prevent="order">

        <div>
          <label for="brochures">Brochure(s)</label>
          <v-select
            required
            id="brochures"
            v-model="selectedBrochures"
            label="brochure_name"
            placeholder="Select brochure(s)"
            multiple
            :options="brochures"
          />
        </div>

        <div>
          <label for="quantity">Quantity</label>
          <input type="number" id="quantity" v-model="quantity" min="1">
        </div>

        <div>
          <label for="affiliates">Affiliates</label>
          <v-select id="affiliates" v-model="affiliate_id" label="name" index="id" :options="affiliates"></v-select>
        </div>

        <button type="submit" class="button button--small" v-if="userRole ==1">Request brochure<span v-if="selectedBrochures.length > 1 || quantity > 1">s</span></button>

      </form>

      <table v-if="requests" class="table" cellspacing="0" cellpadding="0">
				<thead>
					<tr>
            <th>Brochure</th>
            <th>Quantity</th>
            <th>Affiliate</th>
						<th>Requested</th>
            <th>Sent?</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="request of requests" :key="request.id">
            <td>{{ request.brochures_names }}</td>
            <td>{{ request.qty }}</td>
            <td v-if="request.brochure_requester && request.brochure_requester.affiliate">{{ request.brochure_requester.affiliate.name }}</td>
            <td v-else>-</td>
            <td>{{ request.created_at | formatDateTime}}</td>
            <td v-if="request.sent == 0"></td>
            <td v-else>&#10003;</td>
					</tr>
				</tbody>
			</table>

  </div>

</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'BrochureRequests',
  props : {
    customer: Object
  },
  data () {
    return {
      brochures: null,
      requests: null,
      selectedBrochures: 0,
      quantity: 1,
      affiliate_id: null,
      affiliates: []
    }
  },
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  mounted () {
    this.getBrochures()
    this.getRequests()
    this.getAffiliates()
  },
  methods: {
    getBrochures () {
      fetch(this.$api + 'brochures?type=active', {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
      .then(res => res.json())
      .then(response => {
        this.brochures = response.data
      })
    },
    getRequests () {
      fetch(this.$api + 'brochures/requests/by_customer/' + this.customer.id, {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
      .then(res => res.json())
      .then(response => {
        this.requests = response.data
      })
    },
    getAffiliates () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'affiliates?type=active', {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
      .then(res => res.json())
      .then(response => {
        this.affiliates = response.data
        this.$store.dispatch('setLoadStatus')
      })
    },
    order() {
      this.$store.dispatch('setLoadStatus')
      for (let brochure of this.selectedBrochures) {

        var request = {
          customer_id: this.customer.id,
          brochure_id: brochure.id,
          affiliate_id: this.affiliate_id,
          qty: this.quantity
        }

        fetch(this.$api + 'brochures/requests', {
          method: 'POST',
          body: JSON.stringify(request),
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if(response.success == true) {
            this.$notify({
              type: 'success',
              title: response.message
            });
            this.getRequests();
          } else {
            this.$notify({
              type: 'error',
              title: response.message
            });
          }
        })
      }
      this.$store.dispatch('setLoadStatus')
    }
  }
}
</script>

